import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { useFirebase } from 'react-redux-firebase';

/*
  useIsEmailVerified
  - verified returns a boolean value for when the email has been verified
  - requireVerification returns a boolean value for when the client is set to require or allow;
    this prevents users from receiving assessment results email, writing a review and
    signing up to newsletter.
*/

export const getEmailVerificationEnabled = (
  config,
  clientShortName,
  clientGroupShortName,
) => {
  if (!_get(config, 'enabled')) return false;
  if (
    _get(config, 'clientsExclude', []).includes(clientShortName) ||
    _get(config, 'clientsExclude', []).includes(clientGroupShortName)
  )
    return false;
  if (
    !_isEmpty(_get(config, 'clientsInclude', [])) &&
    !_get(config, 'clientsInclude', []).includes(clientShortName) &&
    !_get(config, 'clientsInclude', []).includes(clientGroupShortName)
  )
    return false;

  return true;
};

export const isEmailVerified = user =>
  _get(user, 'providerData.0.providerId') !== 'password' ||
  _get(user, 'emailVerified') === true;

const useIsEmailVerified = () => {
  const firebase = useFirebase();
  const user = firebase.auth().currentUser;
  const clientDetails = useSelector(makeSelectClientDetails());
  const [siteConfig] = useSiteConfigSelector(['Features']);

  const clientShortName = _get(clientDetails, 'shortName');
  const clientGroupShortName = _get(clientDetails, 'clientGroup.shortName');
  const emailValidationConfig = _get(siteConfig, 'config.emailValidation', {});
  const isEnabled = getEmailVerificationEnabled(
    emailValidationConfig,
    clientShortName,
    clientGroupShortName,
  );
  const verified = isEmailVerified(user);
  const requireVerification = isEnabled
    ? true
    : _get(clientDetails, 'signIn') === 'Require';

  const needsVerification = isEnabled && requireVerification && !verified;
  return { verified, isEnabled, requireVerification, needsVerification };
};

export default useIsEmailVerified;
